/**
 * Default take (size of page / number of results)
 */
export const DEFAULT_TAKE = 25
